export default class ProductAction {
    // sbb type


    static SBB_TYPE_REQUEST = 'SBB_TYPE_REQUEST';
    static SBB_TYPE_SUCCESS = 'SBB_TYPE_SUCCESS';
    static SBB_TYPE_FAILED = 'SBB_TYPE_FAILED';



    static sbb_type_Request() {
        return {
            type: this.SBB_TYPE_REQUEST
        }
    }

    static sbb_type_Success(data) {
        return {
            type: this.SBB_TYPE_SUCCESS,
            data
        }
    }

    static sbb_type_Failed(error) {
        return {
            type: this.SBB_TYPE_FAILED,
            error
        }
    }

    static PRODUCT_DEVISIONS_REQUEST = 'PRODUCT_DEVISIONS_REQUEST';
    static PRODUCT_DEVISIONS_SUCCESS = 'PRODUCT_DEVISIONS_SUCCESS';
    static PRODUCT_DEVISIONS_FAILED = 'PRODUCT_DEVISIONS_FAILED';



    static productDevisions_Request() {
        return {
            type: this.PRODUCT_DEVISIONS_REQUEST
        }
    }

    static productDevisions_Success(data) {
        return {
            type: this.PRODUCT_DEVISIONS_SUCCESS,
            data
        }
    }

    static productDevisions_Failed(error) {
        return {
            type: this.PRODUCT_DEVISIONS_FAILED,
            error
        }
    }


    // PRODUCT CUSTOMER 

    static PRODUCT_CUSTOMER_REQUEST = 'PRODUCT_CUSTOMER_REQUEST';
    static PRODUCT_CUSTOMER_SUCCESS = 'PRODUCT_CUSTOMER_SUCCESS';
    static PRODUCT_CUSTOMER_FAILED = 'PRODUCT_CUSTOMER_FAILED';

    static productCustomer_Request() {
        return {
            type: this.PRODUCT_CUSTOMER_REQUEST
        }
    }

    static productCustomer_Success(data) {
        return {
            type: this.PRODUCT_CUSTOMER_SUCCESS,
            data
        }
    }

    static productCustomer_Failed(error) {
        return {
            type: this.PRODUCT_CUSTOMER_FAILED,
            error
        }
    }

    // PRODUCT CATEGORIES

    static PRODUCT_CATEGORIES_REQUEST = 'PRODUCT_CATEGORIES_REQUEST';
    static PRODUCT_CATEGORIES_SUCCESS = 'PRODUCT_CATEGORIES_SUCCESS';
    static PRODUCT_CATEGORIES_FAILED = 'PRODUCT_CATEGORIES_FAILED';

    static productCategories_Request() {
        return {
            type: this.PRODUCT_CATEGORIES_REQUEST
        }
    }

    static productCategories_Success(data) {
        return {
            type: this.PRODUCT_CATEGORIES_SUCCESS,
            data
        }
    }

    static productCategories_Failed(error) {
        return {
            type: this.PRODUCT_CATEGORIES_FAILED,
            error
        }
    }

    // PRODUCT BRANDS

    static PRODUCT_BRANDS_REQUEST = 'PRODUCT_BRANDS_REQUEST';
    static PRODUCT_BRANDS_SUCCESS = 'PRODUCT_BRANDS_SUCCESS';
    static PRODUCT_BRANDS_FAILED = 'PRODUCT_BRANDS_FAILED';

    static productBrands_Request() {
        return {
            type: this.PRODUCT_BRANDS_REQUEST
        }
    }

    static productBrands_Success(data) {
        return {
            type: this.PRODUCT_BRANDS_SUCCESS,
            data
        }
    }

    static productBrands_Failed(error) {
        return {
            type: this.PRODUCT_BRANDS_FAILED,
            error
        }
    }

    // PRODUCT SKUS

    static PRODUCT_SKUS_REQUEST = 'PRODUCT_SKUS_REQUEST';
    static PRODUCT_SKUS_SUCCESS = 'PRODUCT_SKUS_SUCCESS';
    static PRODUCT_SKUS_FAILED = 'PRODUCT_SKUS_FAILED';

    static productSkus_Request() {
        return {
            type: this.PRODUCT_SKUS_REQUEST
        }
    }

    static productSkus_Success(data) {
        return {
            type: this.PRODUCT_SKUS_SUCCESS,
            data
        }
    }

    static productSkus_Failed(error) {
        return {
            type: this.PRODUCT_SKUS_FAILED,
            error
        }
    }

    // PRODUCT MASTER SKUS

    static PRODUCT_MASTER_SKUS_REQUEST = 'PRODUCT_MASTER_SKUS_REQUEST';
    static PRODUCT_MASTER_SKUS_SUCCESS = 'PRODUCT_MASTER_SKUS_SUCCESS';
    static PRODUCT_MASTER_SKUS_FAILED = 'PRODUCT_MASTER_SKUS_FAILED';

    static product_Master_Skus_Request() {
        return {
            type: this.PRODUCT_MASTER_SKUS_REQUEST
        }
    }

    static product_Master_Skus_Success(data) {
        return {
            type: this.PRODUCT_MASTER_SKUS_SUCCESS,
            data
        }
    }

    static product_Master_Skus_Failed(error) {
        return {
            type: this.PRODUCT_MASTER_SKUS_FAILED,
            error
        }
    }


    // PRODUCT PRODUCT VARIANTS

    static PRODUCT_VARIANTS_REQUEST = 'PRODUCT_VARIANTS_REQUEST';
    static PRODUCT_VARIANTS_SUCCESS = 'PRODUCT_VARIANTS_SUCCESS';
    static PRODUCT_VARIANTS_FAILED = 'PRODUCT_VARIANTS_FAILED';

    static productVariants_Request() {
        return {
            type: this.PRODUCT_VARIANTS_REQUEST
        }
    }

    static productVariants_Success(data) {
        return {
            type: this.PRODUCT_VARIANTS_SUCCESS,
            data
        }
    }

    static productVariants_Failed(error) {
        return {
            type: this.PRODUCT_VARIANTS_FAILED,
            error
        }
    }

    // PRODUCT FORMATS

    static PRODUCT_FORMATS_REQUEST = 'PRODUCT_FORMATS_REQUEST';
    static PRODUCT_FORMATS_SUCCESS = 'PRODUCT_FORMATS_SUCCESS';
    static PRODUCT_FORMATS_FAILED = 'PRODUCT_FORMATS_FAILED';

    static productFormats_Request() {
        return {
            type: this.PRODUCT_FORMATS_REQUEST
        }
    }

    static productFormats_Success(data) {
        return {
            type: this.PRODUCT_FORMATS_SUCCESS,
            data
        }
    }

    static productFormats_Failed(error) {
        return {
            type: this.PRODUCT_FORMATS_FAILED,
            error
        }
    }

    //PROCUCT SIZE

    static PRODUCT_SIZE_REQUEST = 'PRODUCT_SIZE_REQUEST';
    static PRODUCT_SIZE_SUCCESS = 'PRODUCT_SIZE_SUCCESS';
    static PRODUCT_SIZE_FAILED = 'PRODUCT_SIZE_FAILED';

    static productSize_Request() {
        return {
            type: this.PRODUCT_SIZE_REQUEST
        }
    }

    static productSize_Success(data) {
        return {
            type: this.PRODUCT_SIZE_SUCCESS,
            data
        }
    }

    static productSize_Failed(error) {
        return {
            type: this.PRODUCT_SIZE_FAILED,
            error
        }
    }


    // ACTIVITY  ENDSTOCK
    static ACTIVITY_END_STOCK_REQUEST = 'ACTIVITY_END_STOCK_REQUEST';
    static ACTIVITY_END_STOCK_SUCCESS = 'ACTIVITY_END_STOCK_SUCCESS';
    static ACTIVITY_END_STOCK_FAILED = 'ACTIVITY_END_STOCK_FAILED';

    static activityEndStock_Request() {
        return {
            type: this.ACTIVITY_END_STOCK_REQUEST
        }
    }

    static activityEndStock_Success(data, page) {
        return {
            type: this.ACTIVITY_END_STOCK_SUCCESS,
            data,
            page
        }
    }

    static activityEndStock_Failed(error) {
        return {
            type: this.ACTIVITY_END_STOCK_FAILED,
            error
        }
    }


    // PRODUCT SECTORS
    static PRODUCT_SECTORS_REQUEST = 'PRODUCT_SECTORS_REQUEST';
    static PRODUCT_SECTORS_SUCCESS = 'PRODUCT_SECTORS_SUCCESS';
    static PRODUCT_SECTORS_FAILED = 'PRODUCT_SECTORS_FAILED';

    static productSectors_Request() {
        return {
            type: this.PRODUCT_SECTORS_REQUEST
        }
    }

    static productSectors_Success(data, page) {
        return {
            type: this.PRODUCT_SECTORS_SUCCESS,
            data,
            page
        }
    }

    static productSectors_Failed(error) {
        return {
            type: this.PRODUCT_SECTORS_FAILED,
            error
        }
    }

}